/**
 * Shared stats sub-components used by MyStatsPage and FriendStatsPage
 */

import React from 'react';

export function formatRuntime(totalMinutes: number): string {
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) {
    // Drop minutes when showing days to keep it compact
    if (hours > 0) {
      return `${days}d ${hours}h`;
    }
    return `${days}d`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
}

export function StatCard({
  label,
  value,
  sub,
}: {
  label: string;
  value: string | number;
  sub?: string;
}) {
  return (
    <div className="stats-card">
      <div className="stats-card-value">{value}</div>
      <div className="stats-card-label">{label}</div>
      {sub && <div className="stats-card-sub">{sub}</div>}
    </div>
  );
}

export function HorizontalBar({
  items,
  maxCount,
}: {
  items: Array<{ name: string; count: number }>;
  maxCount: number;
}) {
  if (items.length === 0) return <div className="empty">No data yet</div>;
  return (
    <div className="stats-bars">
      {items.map((item) => (
        <div key={item.name} className="stats-bar-row">
          <span className="stats-bar-label">{item.name}</span>
          <div className="stats-bar-track">
            <div
              className="stats-bar-fill"
              style={{ width: `${Math.max(4, (item.count / maxCount) * 100)}%` }}
            />
          </div>
          <span className="stats-bar-count">{item.count}</span>
        </div>
      ))}
    </div>
  );
}

export function RankedList({
  items,
  emptyMessage,
}: {
  items: Array<{ name: string; count: number }>;
  emptyMessage?: string;
}) {
  if (items.length === 0) return <div className="empty">{emptyMessage || 'No data yet'}</div>;
  return (
    <div className="stats-ranked-list">
      {items.map((item, index) => (
        <div key={item.name} className="stats-ranked-item">
          <span className="stats-ranked-rank">#{index + 1}</span>
          <span className="stats-ranked-name">{item.name}</span>
          <span className="stats-ranked-count">
            {item.count} {item.count === 1 ? 'movie' : 'movies'}
          </span>
        </div>
      ))}
    </div>
  );
}

export function StatsSection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="stats-section">
      <h3 className="stats-section-title">{title}</h3>
      {children}
    </div>
  );
}
